// extracted by mini-css-extract-plugin
module.exports = {"maxContentWidth":"Alert_maxContentWidth__il0b7"};